import {
  CalendarIcon,
  DatabaseIcon,
  FileTextIcon,
  FingerprintIcon,
  TagsIcon,
  UserIcon,
} from 'lucide-react';

import { Badge } from '@/components/core/badge';
import { Button } from '@/components/core/button';
import { DetailList } from '@/components/detail-list';
import { StatusBadge } from '@/components/status-badge';
import type { SimulationDTO } from '@/gateways/impl/SimulationGateway';
import { formatDateTime } from '@/shared/helpers';
import { simulationInputsStatusType } from '@/shared/status-maps';
import { simulationInputsStatusTitle } from '@/shared/title-maps';

type Props = {
  simulation: Partial<SimulationDTO>;
  isLoading?: boolean;
};

function renderInputsFile(simulation: Partial<SimulationDTO>) {
  if (!simulation.inputDataRef) return undefined;

  if (!simulation.downloadUrl) {
    return <span className="font-mono text-xs">{simulation.inputDataRef}</span>;
  }

  return (
    <span className="font-mono text-xs break-all">
      <Button asChild variant="link" size="inline">
        <a href={simulation.downloadUrl} target="_blank" rel="noreferrer">
          {simulation.inputDataRef}
        </a>
      </Button>
    </span>
  );
}

export function SimulationDetailsSection({ simulation, isLoading }: Props) {
  const status = simulation.inputsStatus;

  return (
    <DetailList
      title="Details"
      isLoading={isLoading}
      items={[
        { icon: TagsIcon, label: 'Name', value: simulation.name },
        {
          icon: TagsIcon,
          label: 'Type',
          value: simulation.type ? <Badge variant="secondary">{simulation.type}</Badge> : undefined,
        },
        {
          icon: DatabaseIcon,
          label: 'Inputs status',
          value: status ? (
            <StatusBadge
              status={status}
              type={simulationInputsStatusType}
              title={simulationInputsStatusTitle}
            />
          ) : undefined,
        },
        { icon: FingerprintIcon, label: 'Inputs hash', value: simulation.inputsHash },
        {
          icon: FileTextIcon,
          label: 'Inputs file',
          value: renderInputsFile(simulation),
        },
        { icon: UserIcon, label: 'Created by', value: simulation.createdBy },
        {
          icon: CalendarIcon,
          label: 'Created',
          value: simulation.createdAt ? formatDateTime(simulation.createdAt) : undefined,
        },
      ]}
    />
  );
}
